import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold uppercase tracking-wider mb-4">
            Opinie
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Zaufanie Użytkowników
          </h2>
          <h3 className="text-2xl md:text-3xl font-heading font-light text-foreground-600 mt-2">
            Rzetelne Recenzje Kakobuy Spreadsheet
          </h3>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="break-inside-avoid mb-5 md:mb-6 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-500">{t.username}</p>
                </div>
              </div>

              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{t.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}